module.exports = __webpack_public_path__ + "static/media/KINGBOARD FR-4 Materials Certifications.fe8f5708.zip";


//////////////////
// WEBPACK FOOTER
// ./src/assets/files/KINGBOARD FR-4 Materials Certifications.zip
// module id = 500
// module chunks = 0